import React from 'react';
import guzzudropLogo from './assets/guzzudrop-logo-128.png';

function AuthBrand() {
  return (
    <div className="auth-brand">
      <img
        className="auth-brand-logo"
        src={guzzudropLogo}
        alt="GuzzuDrop logo"
        width="52"
        height="52"
      />
      <span className="auth-brand-name">GuzzuDrop</span>
    </div>
  );
}

export default AuthBrand;
